export default __webpack_public_path__ + "static/media/operador-de-telemarketing.0a967c32.png";